module.exports = __webpack_public_path__ + "static/media/video-img.31a49112.png";